// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#createEditOrganization[data-v-6e386f29]{color:#999;padding:0px 30px}.modal-container[data-v-6e386f29]{display:block;padding-left:10px}.invisible[data-v-6e386f29]{display:none}input[type=\"file\"][data-v-6e386f29]{display:none}.subNote[data-v-6e386f29]{color:#999}.logoSize[data-v-6e386f29]{color:#e03030;text-align:right}.logoSizeOk[data-v-6e386f29]{color:#509050 !important}.licenseNumberInput[data-v-6e386f29]{display:inline-block;margin:0px 10px 10px 0px}\n", ""]);
// Exports
module.exports = exports;
